import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import {useEffect, useState} from "react";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {NewsService} from "../../serverService/newsService/NewsService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

export default function NewsDetailThumbnail({newsId}) {

    const service = new NewsService()

    const loading = new LoadingHelper(useLoadingDispatcher())
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    useEffect(() => {
        if (typeof newsId !== "undefined" && newsId >= 0) {
            getNewsInfoFromServer()
        }
    }, [newsId])

    const [photoFile, setPhotoFile] = useState("");
    const [photoUrl, setPhotoUrl] = useState("");

    function getNewsInfoFromServer() {
        loading.show()
        service.getThumbnailInfo(newsId)
            .then(response => {
                setPhotoUrl(response.url)
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت تصویر شاخص"))
            loading.hide()
        })
    }

    function handleUpdateThumbnail() {
        if (photoFile) {
            loading.show()
            service.updateThumbnail(newsId, photoFile)
                .then(() => {
                    snackbar.showSuccessMessage("تصویر شاخص با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر شاخص"))
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا ابتدا فایل تصویر شاخص را انتخاب نمایید.")
        }
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <UploadPhoto
                    photoFile={photoFile}
                    setPhotoFile={setPhotoFile}
                    photo={photoUrl}
                    setPhoto={setPhotoUrl}
                />
                <ButtonDivisionSection>
                    <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateThumbnail}/>
                </ButtonDivisionSection>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}